import React from 'react';
import { Color, TypographySize, Weight } from '~/types';
import Typography from '../Typography';
import './label.scss';

type Props = {
    className?: string,
    children: string,
    fontSize?: TypographySize,
    fontWeight?: Weight,
    color?: Color,
}

export default function Label({ className = '', children, fontSize, fontWeight = 'regular', color = 'neutral-300' }: Props): JSX.Element {
    return (
        <div className={`label ${className}`}>
            <Typography
                weight={fontWeight}
                size={fontSize}
                color={color}>
                {children}
            </Typography>
        </div>
    );
}
